import { spotlights } from '@/data/content';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { SEO } from '@/components/SEO';
import { IconLeaf, IconSparkles } from '@tabler/icons-react';

const Spotlights = () => {
  const stats = [
    { label: "Verified Organic", value: "100%", icon: <IconLeaf className="h-8 w-8" /> },
    { label: "Local Suppliers", value: "50+", icon: <IconSparkles className="h-8 w-8" /> },
    { label: "Sustainable Practices", value: "95%", icon: <IconLeaf className="h-8 w-8" /> },
  ];

  return (
    <div className="min-h-screen bg-background py-12">
      <SEO
        title="Our Commitments"
        description="Learn about our commitment to quality, sustainability, and supporting local suppliers."
      />
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between mb-8">
          <h1 className="text-4xl font-bold text-foreground">Our Commitments</h1>
          <Badge variant="secondary">What Makes Us Different</Badge>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 mb-12">
          {stats.map((stat, index) => (
            <Card key={index} className="text-center hover:shadow-lg transition-shadow">
              <CardContent className="pt-6 space-y-4">
                <div className="flex justify-center text-primary">
                  {stat.icon}
                </div>
                <div className="text-4xl font-bold text-primary">{stat.value}</div>
                <p className="text-muted-foreground font-medium">{stat.label}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Spotlights */}
        <div className="grid grid-cols-2 md:grid-cols-2 gap-6">
          {spotlights.map((spotlight, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <CardTitle className="text-2xl">{spotlight.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-muted-foreground text-base">
                  {spotlight.desc}
                </CardDescription>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Spotlights;
